var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.JavaArchive", function(busy, octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canChooseRoles: true,
            canHaveChildren: function() { return true; },
            canBeChild: true,
            hasPackages: function(action) { return true; },
            summaryTemplateUrl: "areas/projects/actions/java_archive/Octopus.JavaArchive_summary.html",
            editTemplateUrl: "areas/projects/actions/java_archive/Octopus.JavaArchive_edit.html",
            features: {
                optional: [
                    "Octopus.Features.CustomScripts",
                    "Octopus.Features.JsonConfigurationVariables",
                    "Octopus.Features.SubstituteInFiles"],
                initial: [
                    "Octopus.Features.SubstituteInFiles" ]
            },
            summaryLink: function ($scope, element) {
                var variableExpressionRegex = /^#{(.*?)}$/;
                var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
                $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];

                matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
                $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
                return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
                    $scope.feedName = feed.Name;
                });
            },
            editLink: function($scope, element, action) {

                $scope.vm = {
                    useCustomInstallDirectory:  !!action.Properties["Octopus.Action.Package.CustomInstallationDirectory"]
                };


                $scope.showPackageFileName = function() {
                   return !action.Properties['Octopus.Action.JavaArchive.DeployExploded'] ||
                       action.Properties['Octopus.Action.JavaArchive.DeployExploded'] === 'False';
                };

                $scope.useCustomInstallDirectoryChanged = function() {
                   if (!$scope.vm.useCustomInstallDirectory) {
                       action.Properties["Octopus.Action.Package.CustomInstallationDirectory"] = null;
                       action.Properties["Octopus.Action.Package.CustomInstallationDirectoryShouldBePurgedBeforeDeployment"] = null;
                       action.Properties["Octopus.Action.Package.CustomInstallationDirectoryPurgeExclusions"] = null;
                   }
                };

            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/java_archive/Octopus.JavaArchive.js
// module id = 376311331133260
// module chunks = 1